import React, {Component} from 'react';
import {connect} from 'react-redux';
// style
import style from '../css/myOffers.css';

import {ASSETS_URL, PROMO_ASSETS_URL} from '../../../constants/endpoints';
// helpers
import {getText} from '../../../helpers/localization';
import {
    openCloseMyOffer,
    openTermsAndConditions,
    setSelectedTCPromoId,
} from "../../../actions/promoBetActions";
import {OPERATOR} from "../../../constants/operator";

const mapStateToProps = (state, ownProps) => {
    return {
        promoBalances: state.vpp.promoBalances,
        selectedTCPromoId: state.vpp.selectedTCPromoId,
        openModalType: state.vpp.openModalType,
        systemLanguage:state.vpp.systemLanguage
    };
};


class MyOffersPopup extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            promoBalances: storeData.vpp.promoBalances,
            selectedTCPromoId: storeData.vpp.selectedTCPromoId,
            cpLabels: [],
            systemLanguage:storeData.vpp.systemLanguage
        }

    }

    componentDidMount() {
        this.state.promoBalances.map((offer, index) => {
            fetch(PROMO_ASSETS_URL + offer.PromoBetId + '/campaignLabel_' + this.state.systemLanguage  + '.json')
                .then(response =>  response.json())
                .then(data => {
                    let label = this.state.cpLabels;
                    label.push(data);
                    let sortedLabel = label.sort(function (a, b) {
                        return a.promoId - b.promoId;
                    });
                    this.setState({cpLabels : sortedLabel});
                })
                .catch((error) => console.log('Error retrieving campaign label file.', error));
        });

    }

    _openTC(promoId){
        this.props.store.dispatch(setSelectedTCPromoId(promoId));
        this.props.store.dispatch(openCloseMyOffer());
        this.props.store.dispatch(openTermsAndConditions());
    }

    render() {
        let store = this.props.store;
        let selectOffer;
        if(this.state.promoBalances.length > 0) {
            selectOffer = <div className={style.subHeading}>{getText('SELECT_OFFER', store)}</div>;
        } else {
            selectOffer = <div className={style.subHeadingNoOffer}>{OPERATOR.currency === 'XXX' ?getText('DEMO_SITE_PROMO_NOT_AVAILABLE', store):getText('NO_OFFER', store)}</div>;
        }
        return (
            <div className={style.myOffersPopupContainer}>
                <div className={`${style.myOffersIconDiv}`}>
                    <img src={`${ASSETS_URL}promo/myOffersIcon.png`} className={`${style.myOffersIcon}`} alt={'bonus'}/>
                </div>
                <div className={style.myOffersHeading}>{getText('MY_OFFERS', store)}</div>
                {selectOffer}
                <div className={style.myOffersTableContainer}>
                    <table className={style.myOffersTable}>
                        {this.state.cpLabels.map((offer, index) => {
                            return (<tbody key={index}>
                                <tr>
                                    <td className={style.myOffersRow}>
                                        <div>
                                            <div className={style.myOffersSelectButtonContainer}>
                                                <div onClick={(event) => this._openTC(offer.promoId)} className={style.myOffersSelectButton}>
                                                    <span  className={style.myOffersSelectButtonText}>
                                                        {getText('SELECT', store)}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className={style.myOffersButtonContainer}>
                                                <div onClick={(event) => this._openTC(offer.promoId)} className={style.myOffersButton} >
                                                    <div className={style.myOffersButtonIconContainer}>
                                                        <img src={`${ASSETS_URL}promo/giftIconWhite.png`} className={style.myOffersButtonIcon} />
                                                    </div>
                                                    <div className={style.myOffersButtonTextContainer}>
                                                        <span className={style.myOffersButtonText}>{offer.label}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>);
                        })}
                    </table>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(MyOffersPopup);












// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/myOffers.js